import { combineReducers } from 'redux';

import screenReducer from './reducers/screenReducer';
import gameDetailsReducer from './reducers/gameDetailsReducer';
import { levelReducer } from './reducers/levelReducer';
import debugReducer from './reducers/debugReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  gameDetails: gameDetailsReducer,
  level: levelReducer,
  debug: debugReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
